import React from 'react';
import CampaignDays from './CampaignDays.jsx';
import CampaignDaysPlaysOnly from './CampaignDaysPlaysOnly.jsx';


function formatDate(date) {
    var options = { month: 'short', day: '2-digit' };
    return date.toLocaleDateString('en-US', options);
  }

function padListWithZeroHours(list, endDate) {
  if (list.length < 1) {
    return list;
  }

  var updatedList = list.slice();
  var nextDate = new Date(list[list.length - 1].date);

  while (nextDate < endDate) {
    var newDate = new Date(nextDate);
    updatedList.push({
      delivered: 0,
      target: 0,
      day: formatDate(newDate),
      date: newDate.toISOString()
    });
    nextDate.setHours(nextDate.getHours() + 1);
  }

  return updatedList;
}

function padListWithZeroDays(list, endDate) {
  if (list.length < 1) {
    return list;
  }

  var updatedList = list.slice();
  var nextDate = new Date(list[list.length - 1].date);
  nextDate.setDate(nextDate.getDate() + 1);
  nextDate.setHours(0, 0, 0, 0);

  while (nextDate <= endDate) {
    updatedList.push({
      delivered: 0,
      target: 0,
      day: formatDate(nextDate),
      date: nextDate.toISOString()
    });

    nextDate.setDate(nextDate.getDate() + 1);
  }
  return updatedList;
}

function dateSorter(a, b) {
  var dateA = new Date(a.date);
  var dateB = new Date(b.date);
  return dateA - dateB;
}


export default class CampaignDaysPlay extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        let showCampaignGraphWithoutArea = this.props.selectedCampaignPromise == 'sov'
        let lineData = this.props.lineData
        let areaData = this.props.areaData
        let endDate = new Date(this.props.endDate)

        if (!this.props.useOldPlay && endDate !== undefined) {
          if (this.props.byDay) {
            lineData = padListWithZeroDays(lineData, endDate);
            areaData = padListWithZeroDays(areaData, endDate);
          }
          else {
            lineData = padListWithZeroHours(lineData, endDate);
            areaData = padListWithZeroHours(areaData, endDate);
          }
          lineData.sort(dateSorter);
          areaData.sort(dateSorter);
        }

        return (
            <div>
                {showCampaignGraphWithoutArea ?
                    <CampaignDaysPlaysOnly
                        color1={this.props.color1}
                        color2={this.props.color2}
                        lineData={lineData}
                        lineName="Plays"
                        lineMaxScale={1.9}
                        graphHeader="Campaign Period"
                        height={150}
                        label={this.props.label}
                        byDay={this.props.byDay}
                    />
                :
                    <CampaignDays
                        color1={this.props.color1}
                        color2={this.props.color2}
                        areaData={areaData}
                        areaName={this.props.areaLabel}
                        areaMaxScale={1.1}
                        lineData={lineData}
                        lineName="Plays"
                        lineMaxScale={1.9}
                        graphHeader="Campaign Period"
                        height={150}
                        label={this.props.label}
                        byDay={this.props.byDay}
                    />
                }
            </div>
        );
    }
}